/* AR: every <details> accordion on the site slides open and closed instead of jumping.
   One owner for the motion: the <details> element animates its own height (summary height ⇄ full height), so
   panels with any padding work, and the +/− or chevron (CSS on [open]) turns at the same pace.
   The panel under the summary fades in as the row grows (this replaces the former assets/ar-faq.js).
   Delegated on document, so content rendered later (cart drawer, section re-renders) is covered too.
   Skipped for the header/menu/search/filter disclosures (they have their own behaviour) and under reduced motion. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SKIP = 'details-disclosure, header-drawer, .menu-drawer-container, .menu-drawer, .mega-menu, .header__search, .facets, .mobile-facets__disclosure, .password-modal, .ar-full-ing, [class*="disclosure"]';
  var running = new WeakMap();
  document.addEventListener('click', function (e) {
    var sm = e.target.closest('summary');
    if (!sm || e.defaultPrevented) return;
    var d = sm.parentElement;
    if (!d || d.tagName !== 'DETAILS' || sm !== d.firstElementChild) return;
    if (d.closest(SKIP) || d.matches(SKIP)) return;
    e.preventDefault();
    var prev = running.get(d);
    if (prev) prev.cancel();
    var from = d.offsetHeight;
    d.style.overflow = 'hidden';
    var anim;
    if (d.open) {
      var to = d.dataset.arClosedH ? parseFloat(d.dataset.arClosedH) : sm.offsetHeight;
      d.style.height = from + 'px';
      anim = d.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: 260, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
      anim.onfinish = function () { d.open = false; d.style.height = ''; d.style.overflow = ''; running.delete(d); anim.cancel(); };
    } else {
      d.dataset.arClosedH = from;
      d.open = true;
      var full = d.offsetHeight;
      var panel = sm.nextElementSibling;
      if (panel && panel.animate) panel.animate({ opacity: [0, 1], transform: ['translateY(-4px)', 'none'] }, { duration: 320, easing: 'cubic-bezier(.22,.61,.36,1)' });
      d.style.height = from + 'px';
      anim = d.animate([{ height: from + 'px' }, { height: full + 'px' }], { duration: 340, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' });
      anim.onfinish = function () { d.style.height = ''; d.style.overflow = ''; running.delete(d); anim.cancel(); };
    }
    anim.oncancel = function () { d.style.height = ''; d.style.overflow = ''; if (running.get(d) === anim) running.delete(d); };
    running.set(d, anim);
  });
})();
